/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { get } from 'lodash';

// Components
import BaseSelect from 'shared/ui/components/form-components/BaseSelect.vue';
import RadioButtons from 'shared/ui/components/form-components/RadioButtons.vue';
import Toggler from 'shared/ui/components/form-components/Toggler.vue';

const __vue_script__ = {
    name: 'CheckinTypeOptions',

    components: {
        BaseSelect,
        RadioButtons,
        Toggler
    },

    props: {
        event: {
            type: Object,
            required: true
        },

        config: {
            type: Object,
            required: true
        },

        fields: {
            type: Array,
            required: true
        },

        stationType: {
            type: String,
            required: true
        },

        value: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            metadata_search_fields: [],
            metadata_display_fields: [],
            metadata_printing: [],
            metadata_match: 'exact',
            skip_printing: false,
            scanning_enabled: false,
            printing_enabled: false,
            search_enabled: false,
            searchMethods: get(this.config, 'metadata_match.kind_options.choices', []),
        };
    },

    watch: {
        value: {
            immediate: true,
            handler(value) {
                if (value.metadata_match) {
                    this.metadata_match = value.metadata_match;
                }

                this.skip_printing = get(value, 'skip_printing', false);
                this.scanning_enabled = get(value, 'scanning_enabled', false);
                this.printing_enabled = get(value, 'printing_enabled', false);
                this.search_enabled = get(value, 'search_enabled', false);
            },
        },

        fields: {
            immediate: true,
            handler() {
                this.computeFields();
            }
        }
    },

    methods: {
        computeFields() {
            if (this.value.metadata_display_fields?.length) {
                this.metadata_display_fields = this.fields.filter(f => this.value.metadata_display_fields.includes(f.value));
            } else {
                const defaultValues = get(this.config, 'metadata_display_fields.kind_options.default', []);
                this.metadata_display_fields = this.fields.filter(f => defaultValues.includes(f.value));
            }

            if (this.value.metadata_search_fields?.length) {
                this.metadata_search_fields = this.fields.filter(f => this.value.metadata_search_fields.includes(f.value));
            } else {
                const defaultValues = get(this.config, 'metadata_search_fields.kind_options.default', []);
                this.metadata_search_fields = this.fields.filter(f => defaultValues.includes(f.value));
            }

            if (this.value.metadata_printing?.length) {
                this.metadata_printing = this.fields.filter(f => this.value.metadata_printing.includes(f.value));
            } else {
                const defaultValues = get(this.config, 'metadata_printing.kind_options.default', []);
                this.metadata_printing = this.fields.filter(f => defaultValues.includes(f.value));
            }
        },

        emit() {
            const payload = {
                scanning_enabled: this.scanning_enabled,
                metadata_printing: this.metadata_printing.map(f => f.value),
                printing_enabled: this.printing_enabled,
                search_enabled: this.search_enabled,
                skip_printing: this.skip_printing
            };

            if (payload.search_enabled) {
                payload['metadata_search_fields'] = this.metadata_search_fields.map(f => f.value);
                payload['metadata_display_fields'] = this.metadata_display_fields.map(f => f.value);
                payload['metadata_match'] = this.metadata_match;
            }

            this.$emit('input', payload);
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "checkin-type-options" },
    [
      _c("toggler", {
        attrs: {
          name: "scanning_enabled_" + _vm.stationType,
          "on-label": _vm.$t("onsite_scanning.settings.scanning_enabled.label"),
          "off-label": _vm.$t(
            "onsite_scanning.settings.scanning_enabled.label"
          ),
        },
        on: { input: _vm.emit },
        model: {
          value: _vm.scanning_enabled,
          callback: function ($$v) {
            _vm.scanning_enabled = $$v
          },
          expression: "scanning_enabled",
        },
      }),
      _c("toggler", {
        attrs: {
          name: "search_enabled_" + _vm.stationType,
          "on-label": _vm.$t("onsite_scanning.settings.search_enabled.label"),
          "off-label": _vm.$t("onsite_scanning.settings.search_enabled.label"),
        },
        on: { input: _vm.emit },
        model: {
          value: _vm.search_enabled,
          callback: function ($$v) {
            _vm.search_enabled = $$v
          },
          expression: "search_enabled",
        },
      }),
      _vm.search_enabled
        ? _c(
            "div",
            { staticClass: "feature-dependant" },
            [
              _c("validation-provider", {
                attrs: {
                  rules: "required",
                  slim: true,
                  name: "metadata_search_fields_" + _vm.stationType,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (ref) {
                        var errors = ref.errors
                        return [
                          _c("base-select", {
                            attrs: {
                              name: "metadata_search_fields_" + _vm.stationType,
                              "track-by": "value",
                              label: _vm.$t(
                                "onsite_scanning.settings.metadata_search_fields.label"
                              ),
                              options: _vm.fields,
                              errors: errors,
                              multiple: true,
                            },
                            on: { input: _vm.emit },
                            model: {
                              value: _vm.metadata_search_fields,
                              callback: function ($$v) {
                                _vm.metadata_search_fields = $$v
                              },
                              expression: "metadata_search_fields",
                            },
                          }),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2110412141
                ),
              }),
              _c("validation-provider", {
                attrs: {
                  rules: "required",
                  slim: true,
                  name: "metadata_display_fields_" + _vm.stationType,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (ref) {
                        var errors = ref.errors
                        return [
                          _c("base-select", {
                            attrs: {
                              name:
                                "metadata_display_fields_" + _vm.stationType,
                              "track-by": "value",
                              label: _vm.$t(
                                "onsite_scanning.settings.metadata_display_fields.label"
                              ),
                              options: _vm.fields,
                              errors: errors,
                              multiple: true,
                            },
                            on: { input: _vm.emit },
                            model: {
                              value: _vm.metadata_display_fields,
                              callback: function ($$v) {
                                _vm.metadata_display_fields = $$v
                              },
                              expression: "metadata_display_fields",
                            },
                          }),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3635010745
                ),
              }),
              _c("validation-provider", {
                attrs: {
                  rules: "required",
                  slim: true,
                  name: "metadata_match_" + _vm.stationType,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (ref) {
                        var errors = ref.errors
                        return [
                          _c("radio-buttons", {
                            attrs: {
                              name: "metadata_match_" + _vm.stationType,
                              label: _vm.$t(
                                "onsite_scanning.settings.metadata_match.label"
                              ),
                              options: _vm.searchMethods,
                              errors: errors,
                            },
                            on: { input: _vm.emit },
                            model: {
                              value: _vm.metadata_match,
                              callback: function ($$v) {
                                _vm.metadata_match = $$v
                              },
                              expression: "metadata_match",
                            },
                          }),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3240808592
                ),
              }),
            ],
            1
          )
        : _vm._e(),
      _c("toggler", {
        attrs: {
          name: "printing_enabled_" + _vm.stationType,
          "on-label": _vm.$t("onsite_scanning.settings.printing_enabled.label"),
          "off-label": _vm.$t(
            "onsite_scanning.settings.printing_enabled.label"
          ),
        },
        on: { input: _vm.emit },
        model: {
          value: _vm.printing_enabled,
          callback: function ($$v) {
            _vm.printing_enabled = $$v
          },
          expression: "printing_enabled",
        },
      }),
      _vm.printing_enabled
        ? _c(
            "div",
            { staticClass: "feature-dependant" },
            [
              _c("toggler", {
                attrs: {
                  name: "skip_printing_" + _vm.stationType,
                  "on-label": _vm.$t(
                    "onsite_scanning.settings.printer.skip_printing.label"
                  ),
                  "off-label": _vm.$t(
                    "onsite_scanning.settings.printer.skip_printing.label"
                  ),
                },
                on: { input: _vm.emit },
                model: {
                  value: _vm.skip_printing,
                  callback: function ($$v) {
                    _vm.skip_printing = $$v
                  },
                  expression: "skip_printing",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c("validation-provider", {
        attrs: {
          rules: "required",
          slim: true,
          name: "metadata_printing_" + _vm.stationType,
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var errors = ref.errors
              return [
                _c("base-select", {
                  attrs: {
                    name: "metadata_printing_" + _vm.stationType,
                    "track-by": "value",
                    label: _vm.$t(
                      "onsite_scanning.settings.metadata_printing.label"
                    ),
                    options: _vm.fields,
                    errors: errors,
                    multiple: true,
                  },
                  on: { input: _vm.emit },
                  model: {
                    value: _vm.metadata_printing,
                    callback: function ($$v) {
                      _vm.metadata_printing = $$v
                    },
                    expression: "metadata_printing",
                  },
                }),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/printing/CheckinTypeOptions.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__